<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/Defining_Scope_Rules/The_Scoper_Definition';
    let nextLink= '/Documentation/Typing_and_Validating/Type_Provider';
    
    import Note from "$lib/notes/Note.svelte";
</script>

<PrevNextSection {prevLink} {nextLink} />



<SectionComponent tag="h1" 
  id="typing-and-validating-1"
  bind:intersecting={visibleById["typing-and-validating-1"]}
  onIntersectChange={(visible) => setVisible("typing-and-validating-1", visible)}
>Typing and Validating</SectionComponent>
<p>Besides the concrete syntax and scoping, typing and validation are important parts of a language
definition. Freon provides default implementations and generation tools for each of them.</p>
<p>Each generator takes as input a separate definition file and can be run independently. For instance,
you can use one of the following commands:</p>
<pre class="language-bash"><code class="language-bash">npm run freon type-it -d src/defs -o src/
npm run freon validate-it -d src/defs -o src/</code></pre>
<Note>{#snippet header()} Incomplete code{/snippet}
{#snippet content()}
<p>
Keep in mind that all commands, except <code>all</code>, when used individually (i.e., without combining 
them with others), may produce code that does <b>not compile correctly</b>. For example, the <code>scoper</code> 
and <code>validator</code> may depend on the <code>typer</code> and attempt to reference its class, 
which might not yet be generated. Similarly, the <code>editor</code> may try to include 
the <code>scoper</code>.
</p>
<p>
To avoid such issues, it is recommended to start with the <code>all</code> command. Once it 
has been run, you can use specific commands for individual aspects of your language as needed. 
This approach ensures that all dependencies are correctly in place while minimizing regeneration time.
</p>
{/snippet}
 </Note>


<PrevNextSection {prevLink} {nextLink} />